import React from 'react';
import { ajaxActions } from '../AjaxActions';

const BASE_URL = process.env.REACT_APP_FILE_SERVICE_URL;

export const fetchFileSizeOfProfile = () => ajaxActions.get(`${BASE_URL}/fileSize`).then((resp) => resp);

export const fetchFileSizeOfFolder = (folderName) =>
  ajaxActions.get(`${BASE_URL}/fileSize/${folderName}`).then((resp) => resp);
